export const charlieCardCmskeys = ({
	placeholderCharlieTemporary: 'miscText.card-settings-type-temporary',
	placeholderCharliePhysical: 'miscText["addcard-charlie-physical-nickname.placeholder"]',
	placeholderCharlieVirtual: 'miscText["addcard-charlie-virtual-nickname.placeholder"]',
	placeholderEmv: 'miscText["addcard-emv-nickname.placeholder"]',
	placeholderEmvWallet: 'miscText["addcard-wallet-emv-nickname.placeholder"]',
	placeholderAppleWallet: 'miscText.addcard-wallet-apple-nickname.placeholder',
});
